import { render, staticRenderFns } from "./moveableItem.vue?vue&type=template&id=0b87937e&scoped=true&"
import script from "./moveableItem.vue?vue&type=script&lang=ts&"
export * from "./moveableItem.vue?vue&type=script&lang=ts&"
import style0 from "./moveableItem.vue?vue&type=style&index=0&id=0b87937e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b87937e",
  null
  
)

component.options.__file = "moveableItem.vue"
export default component.exports